import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import ContentListing from "@/pages/ContentListing";
const ContentListingRoute = () => <ContentListing contentType="company_news" pageTitle="Company News" pageDescription="The latest announcements, partnerships, and milestones from QbD Group — stay informed on our growth and impact." />;

export const Route = createFileRoute("/en/news/")({
  head: () => buildRouteHead("/en/news"),
  component: ContentListingRoute,
});

